module.exports = __webpack_public_path__ + "img/kanban-link-icon.4f899647.svg";